/* eslint-disable react/jsx-sort-props */
export const TimelineSegments = ({
  variant = '3/3',
}: {
  variant: '1/3' | '2/3' | '3/3'
}) => {
  return (
    <div className='relative inline-block h-[76px] w-full align-middle'>
      <svg
        className='absolute top-0 inline-block'
        viewBox='0 0 1754 124'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M517.143 0H1085L1155.86 124H588L517.143 0Z'
          fill={variant === '1/3' ? '#C5B4EC' : 'url(#paint0_linear_176_274)'}
        />
        <path
          d='M1093.86 0H1736C1745.78 0 1753.71 7.93095 1753.71 17.7143V106.286C1753.71 116.069 1745.78 124 1736 124H1164.71L1093.86 0Z'
          fill={variant !== '3/3' ? '#C5B4EC' : 'url(#paint1_linear_176_274)'}
        />
        <path
          d='M0 17.7143C0 7.93096 7.93096 0 17.7143 0H508.286L579.143 124H17.7143C7.93096 124 0 116.069 0 106.286V17.7143Z'
          fill='url(#paint2_linear_176_274)'
        />
        <defs>
          <linearGradient
            id='paint0_linear_176_274'
            x1='586'
            y1='62'
            x2='1124.5'
            y2='62'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#5178EC' />
            <stop offset='1' stopColor='#916EDA' />
          </linearGradient>
          <linearGradient
            id='paint1_linear_176_274'
            x1='1129.5'
            y1='62'
            x2='1754'
            y2='62'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#906FDB' />
            <stop offset='1' stopColor='#AC63C4' />
          </linearGradient>
          <linearGradient
            id='paint2_linear_176_274'
            x1='-1.66845e-05'
            y1='72.8772'
            x2='390.197'
            y2='345.403'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#2381FF' />
            <stop offset='1' stopColor='#5078EC' />
          </linearGradient>
        </defs>
      </svg>
    </div>
  )
}
